import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5ff2aa98"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Complete Pathway?")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "paragraph-one" }, " Marking this Pathway as complete will close the Pathway for all team members. ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "paragraph-two" }, " Team members will see the Congratulations page when they next visit your Team Dashboard. The Pathway will also be closed for any team members who have not completed all of the Pathway Steps, so best to check before you hit 'Complete'! ", -1))

import { ref, computed } from "vue";
import { Modal } from "uiv";
import axios from "axios";
import { debug as d } from "debug";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'complete-page-modal',
  props: {
    teamId: {},
    pathwayId: {}
  },
  setup(__props: any, { expose: __expose }) {

const debug = d("cs.CompletePageModal");

const props = __props;

const isModalOpen = ref(false);
const route = useRoute();
const asaccredited = computed(() => route.query.asaccredited as string);

function openModal(): void {
  isModalOpen.value = !isModalOpen.value;
}

async function completePathwayForTeam(): Promise<void> {
  try {
    await axios.post("/api/TeamMemberCompletedPathway", {
      teamId: props.teamId,
      cmsPathwayId: props.pathwayId,
    });
  } catch (e) {
    debug(e);
  } finally {
    window.location.href = asaccredited.value === 'true'
              ? `/myorganisation/group/details/${props.teamId}`
      : `/home?view=TeamDashboard&team=${props.teamId}`;
  }
}

__expose({
  openModal,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal), {
    modelValue: isModalOpen.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isModalOpen).value = $event)),
    header: false,
    footer: false,
    class: "outcome-modal"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", { class: "modal-content-container" }, [
        _hoisted_1,
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", { class: "modal-footer" }, [
          _createElementVNode("button", {
            class: "btn btn-default",
            onClick: openModal,
            type: "button"
          }, "Cancel"),
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: completePathwayForTeam,
            "data-test": "admin-complete-pathway-btn",
            type: "button"
          }, " Complete ")
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})